export default "__VITE_ASSET__DCaWd8_M__"